import { action } from 'satcheljs';
import ScopeOption from '../types/ScopeOption';

const onFolderDropdownOptionSelected = action(
    'onFolderDropdownOptionSelected',
    (selectedScopeOption: ScopeOption) => ({
        selectedScopeOption,
    })
);

export default onFolderDropdownOptionSelected;
